var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-4948 -1564.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M5420.017,1302.551a6.469,6.469,0,0,1,4.881-.6c3.042.678,4.593-2.153,6.5-.738s0,4.953,0,4.953l-11.731-.077Z",
    transform: "translate(-448.247 273.767)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 20.571,
    height: 32.617,
    transform: "translate(4959.042 1568.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M0,34.271V1.725c.012-.012.032-.022.034-.036A1.943,1.943,0,0,1,.941.3,3.043,3.043,0,0,1,1.72,0H34.179c.012.012.022.032.036.034A1.973,1.973,0,0,1,35.9,2q0,15.991,0,31.981a1.918,1.918,0,0,1-.064.5A1.982,1.982,0,0,1,33.869,36q-4.44,0-8.88,0c-.164,0-.2-.037-.2-.2q.008-6.777,0-13.554c0-.166.04-.2.2-.2,1.421.007,2.842,0,4.263.006.116,0,.19,0,.209-.156q.316-2.529.651-5.055c.025-.19-.035-.213-.2-.212-1.639.005-3.278,0-4.917.007-.175,0-.213-.05-.212-.217.008-1.087,0-2.175,0-3.262a6.511,6.511,0,0,1,.039-.729,1.878,1.878,0,0,1,1.64-1.821,4.862,4.862,0,0,1,1.022-.093c.885,0,1.77,0,2.655,0,.144,0,.187-.033.186-.184q-.009-2.231,0-4.462c0-.175-.045-.229-.222-.245-1.049-.1-2.1-.14-3.154-.167a10.8,10.8,0,0,0-2.787.209,5.984,5.984,0,0,0-4.185,3.189,7.934,7.934,0,0,0-.8,3.589c-.011,1.325-.007,2.649,0,3.974,0,.177-.051.215-.218.214-1.427-.006-2.854,0-4.281-.008-.176,0-.213.051-.213.219q.009,2.5,0,5.005c0,.173.05.2.208.2,1.433-.006,2.867,0,4.3-.008.167,0,.2.043.2.206q-.007,6.767,0,13.535c0,.187-.053.22-.227.22Q11.881,35.992,4.8,36c-.941,0-1.882.009-2.823,0a1.954,1.954,0,0,1-1.638-.876A2.855,2.855,0,0,1,0,34.271",
    transform: "translate(4948 1564.976)",
    fill: "#0066fe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0e79e6d2aebaa4ca107e67e7299488db.svg";
export { ForwardRef as ReactComponent };